const MODULE_URL = 'search';

export default {
  MODULE_URL: MODULE_URL,
  INSTANCES_URL: MODULE_URL,

  SEARCH_TYPES_URL: MODULE_URL + '/types',
  SEARCH_TYPES_UPDATED: 'search_types_updated',

  DEFAULT_SEARCH_TYPE: 'any',

  VIEW_ID: 'search',
};
